import React from 'react'
import './Blogs.css'
export default function Blogs() {
    return (
        <div className='blogbody'>
            <div className="blogcard">
                <p className='date'>14th February,2022</p>
                <p className='blogpara'>In the days when an ice cream sundae cost much less, a 10 year old boy entered a hotel coffee shop and sat at a table. A waitress put a glass of water in front of him.</p>
                <p className='blogpara'>‘How much is an ice cream sundae?’</p>
                <p className='blogpara'>‘50 cents,’ replied the waitress.</p>
                <p className='blogpara'>The little boy pulled his hand out of his pocket and studied a number of coins in it.</p>
                <p className='blogpara'>‘How much is a dish of plain ice cream?’ he inquired. Some people were now waiting for a table and the waitress was a bit impatient.</p>
                <p className='blogpara'>The little boy again counted the coins. ‘I’ll have the plain ice cream,’ he said.</p>
                <p className='blogpara'>The waitress brought the ice cream, put the bill on the table and walked away. The boy finished the ice cream, paid the cashier and departed.</p>
                <p className='blogpara'>When the waitress came back, she began wiping down the table and then swallowed hard at what she saw.</p>
                <p className='blogpara'>There, placed neatly beside the empty dish, were 15 cents – her tip.</p>
                <p className='blogpara'><b>Be kind to others even if it hurts you :)</b></p>
            </div>
        </div>
    )
}
